import Container from "@/components/common/Container";
import PrimaryButton from "@/components/common/PrimaryButton";
import Image from "next/image";

const Hero = () => (
  <>
    <Container
      large
      className="bg-header-background bg-bottom bg-no-repeat bg-cover pt-36 xl:pt-48"
    >
      <span className="text-primary-yellow font-500 xl:pb-6 inline-block text-2xl md:text-xl mb-4 md:mb-0 font-medium">
        Services
      </span>
      <h1 className="text-white md:text-6xl w-full md:w-3/5 text-4xl md:leading-tight font-medium">
        <span>Seamless Data Extraction: Best Web Scraping API</span>
      </h1>
    </Container>
    <Container large className="bg-primary-black pb-36 md:pb-40">
      <div className="pt-14 md:pt-16 fs-0 pb-4 xl:pb-12 mb-4 xl:mb-12">
        <Image
          alt="consulting"
          className=" "
          height={603}
          src="/assets/data-solution/dataSolutionInnerPage/webapihero.webp"
          width={1320}
        />
      </div>
      <div className="px-0 md:pl-64 md:pr-40">
        <p className="text-white text-base text-justify pb-8">
          <span>
            Begin your data extraction adventure with our cutting-edge&nbsp;
            <b>Web Scraping API.</b> Explore the seamless world of information
            retrieval, where our API empowers you to effortlessly gather and
            integrate data from various online sources. No more manual
            hassle—say hello to efficiency. Picture a realm where information
            flows seamlessly into your applications, providing real-time updates
            and insights. Our&nbsp;
            <b>Data Scraping API</b> is crafted with simplicity and reliability
            in mind, ensuring a smooth integration experience. Dive into the
            world of automation and unleash the full potential of your
            data-driven initiatives with our robust and user-friendly&nbsp;
            <b>Web Scraping API.</b>
          </span>
        </p>
        <PrimaryButton
          arrow={false}
          link="#DataScraping-enterprise"
          val="Talk to an expert"
        />
      </div>
    </Container>
  </>
);

export default Hero;
